import React from "react";
import { Divider } from "@chakra-ui/layout";

export const SectionDivider = () => {
  return <Divider borderBottom="1px solid #ECEAF0" pt="6" mb="6" />;
};
